<template>
    <div :class="panelblock ? 'c-form-radio-block' : 'c-form-radio'">
        <div class="c-form-radio__option" v-for="(option,index) in options">
            <input
                type="radio"
                :name="name"
                :required="required"
                :value="option.value"
                :checked="option.value == value"
                :id="name + '-' + index"
                @input="$emit('input', $event.target.value)"
            /><label :for="name + '-' + index">{{option.label}}</label>
        </div>
    </div>
</template>

<script>
import Utils from '@classes/Utils';

export default {
    props: {
        options: {
            type: Array,
            required: true
        },
        value: {
            required: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        panelblock: {
            type: Boolean,
            default: true
        },
        name: {
            type:String,
            default: () => Utils.generateUid()
        }
    }
}
</script>
